module.exports = __webpack_public_path__ + "static/media/drNathannaelStricker.00be7ff8.JPG";